import updateFirstNameCopy from 'core/DOM/updateFirstNameCopy'
import textContent from 'utils/DOM/textContent'
import { isArray } from '@hc-frontend/utils'
import store from 'utils/store/withMiddleware'

function setUpDiscoveryProcess() {
  const { hcStorage } = store.getState()

  updateFirstNameCopy({ hcStorage })

  if (isArray(hcStorage.members) && hcStorage.members.length > 1) {
    textContent('.js-family', 'me and my family')
  }

  document.body.classList.add('discovery-process')
}

export default setUpDiscoveryProcess
